import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["subproduct"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSessionId } from '../../utils/createSessionId';
import { isContextChanged } from './utils/isContextChanged';
import { mapSubproduct } from './utils/mapSubproduct';
var defaultsMiddleware = function defaultsMiddleware(context) {
  return context;
};
var createSessionIdMiddleware = function createSessionIdMiddleware() {
  var previousContext;
  return function (context) {
    if (previousContext === undefined && context.sessionId) {
      previousContext = context;
      return context;
    }
    if (!context.sessionId || isContextChanged(previousContext, context)) {
      var newContext = _objectSpread(_objectSpread({}, context), {}, {
        sessionId: createSessionId()
      });
      previousContext = newContext;
      return newContext;
    }
    return context;
  };
};
export var subProductMiddleware = function subProductMiddleware(_ref) {
  var subproduct = _ref.subproduct,
    context = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread(_objectSpread({}, context), {}, {
    subproduct: mapSubproduct(subproduct)
  });
};
export var createContextMiddleware = function createContextMiddleware() {
  /**
   * Session id refers to a context session. When context changes the session will update
   */
  var sessionIdMiddleware = createSessionIdMiddleware();
  return function (context) {
    return defaultsMiddleware(subProductMiddleware(sessionIdMiddleware(context)));
  };
};